//import TodoInfoArrFunc from "@/pcomponents/common/content/todo/list/info_arr_func";
import TodoStateFunc from "@/pcomponents/common/content/todo/state/func/state_func";
import strFunc from '@/lib/lyg/string';

class TodoInfoArrFunc 
{
  static get_info_arr_by_filter(inData: any) {
    let opt_obj = {
      info_arr: [],//user_info_arr
      list_opt: {
        s_addon_todo_start_date: "",
        s_addon_todo_s_state: "",//complete,ing,not_complete
        s_addon_todo_s_todo_sort: "",//study,homework
      },
      ...inData
    };
    let info_arr = opt_obj["info_arr"];
    let base_date_str = opt_obj["base_date_str"];
    let pre_date_str = opt_obj["pre_date_str"];

    let new_info_arr = [];
    let info_arr_len = info_arr.length;
    for (let i = 0; i < info_arr_len; i++) {
      let info = info_arr[i];
      let td_sort_data_json = this.get_td_sot_data_arr({
        info: info,
        base_date_str: base_date_str,
        pre_date_str: pre_date_str,
      });
      info.td_sort_data_json = td_sort_data_json;

      let is_add_info = true;
      if (opt_obj["list_opt"]["s_addon_todo_s_state"] != "") {
        is_add_info = false;
        let todo_percent = info.td_sort_data_json["study"]["percent"];
        let todo_count = info.td_sort_data_json["study"]["count"];
        if (opt_obj["list_opt"]["s_addon_todo_s_todo_sort"] == "homework") {
          todo_percent = info.td_sort_data_json["pre_homework"]["percent"];
          todo_count = info.td_sort_data_json["pre_homework"]["count"];
        }
        if (opt_obj["list_opt"]["s_addon_todo_s_state"] == "complete") {
          if (todo_percent >= 100) {
            is_add_info = true;
          }
        } else if (opt_obj["list_opt"]["s_addon_todo_s_state"] == "ing") {
          if (todo_percent > 0 && todo_percent < 100) {
            is_add_info = true;
          }
        } else {
          if (todo_percent >= 0 && todo_percent < 100 && todo_count > 0) {
            is_add_info = true;
          }
        }
      }
      if (is_add_info) {
        new_info_arr.push(info);
      }
    }
    info_arr = new_info_arr;

    return info_arr;
  };
  static get_td_sot_data_arr = (inData: any) => {
    let opt_obj = {
      info: {},
      base_date_str: "",
      pre_date_str: "",
      ...inData,
    };
    let info = opt_obj.info;
    let base_date_str = opt_obj.base_date_str;
    let pre_date_str = opt_obj.pre_date_str;
    let this_obj = this;
    let default_sort_data_json_row = {
      "sort": "study",
      "title": "수업",
      "percent": 0,//유도리
      "count": 0,
      "percent2": 0,//정확히
      "success_cnt": 0,
      "elapse_time_sec": 0,
      "per_arr": [],
      "todo_info_arr": [],
      "subject_name_arr": [],
      "subject_data_json": {},
      "file_cnt": 0,
      "file_arr": [],
    };
    let td_sort_data_json: any = {
      "study": {
        ...default_sort_data_json_row,
        "sort": "study",
        "title": "수업",
        "per_arr": [],
        "todo_info_arr": [],
        "subject_name_arr": [],
        "subject_data_json": {},
        "file_cnt": 0,
        "file_arr": [],
      },
      "homework": {
        ...default_sort_data_json_row,
        "sort": "homework",
        "title": "숙제",
        "per_arr": [],
        "todo_info_arr": [],
        "subject_name_arr": [],
        "subject_data_json": {},
        "file_cnt": 0,
        "file_arr": [],
      },
      "pre_homework": {
        ...default_sort_data_json_row,
        "sort": "pre_homework",
        "title": "숙제",
        "per_arr": [],
        "todo_info_arr": [],
        "subject_name_arr": [],
        "subject_data_json": {},
        "file_cnt": 0,
        "file_arr": [],
      },
    };
    let todo_info_arr = [];
    if (info.todo_arr) {
      todo_info_arr = info.todo_arr;
    }

    for (let key in td_sort_data_json) {
      td_sort_data_json[key] = this_obj.get_td_sort_data_by_key({
        sort_data_json_row: td_sort_data_json[key],
        key: key,
        todo_info_arr: todo_info_arr,
        base_date_str: base_date_str,
        pre_date_str: pre_date_str,
      });
    }
    //평균얻기
    for (let key in td_sort_data_json) {
      let row_sort_data_json = td_sort_data_json[key];
      row_sort_data_json["percent"] = this_obj.average_percent_arr_by_opt({
        per_arr: row_sort_data_json["per_arr"],
        is_max_per: true,
      });
      row_sort_data_json["percent2"] = this_obj.average_percent_arr_by_opt({
        per_arr: row_sort_data_json["per_arr"],
        is_max_per: false,
      });

      for (let subject_key in row_sort_data_json["subject_data_json"]) {
        let subject_data_json = row_sort_data_json["subject_data_json"][subject_key];
        subject_data_json["percent"] = this_obj.average_percent_arr_by_opt({
          per_arr: subject_data_json["per_arr"],
          is_max_per: true,
        });
        subject_data_json["percent2"] = this_obj.average_percent_arr_by_opt({
          per_arr: subject_data_json["per_arr"],
          is_max_per: false,
        });
        row_sort_data_json["subject_data_json"][subject_key] = subject_data_json;
      }

      td_sort_data_json[key] = row_sort_data_json;
    }

    return td_sort_data_json;
  };
  static get_td_sort_data_by_key(inData: any) {
    let opt_obj = {
      sort_data_json_row: {},
      key: "",
      todo_info_arr: [],
      base_date_str: "",
      pre_date_str: "",
      ...inData,
    };
    let sort_data_json_row = opt_obj.sort_data_json_row;
    let key = opt_obj.key;
    let todo_info_arr = opt_obj.todo_info_arr;
    let base_date_str = opt_obj.base_date_str;
    let pre_date_str = opt_obj.pre_date_str;
    let todo_info_arr_len = todo_info_arr.length;
    let this_obj = this;

    //subject_data_json
    let default_subject_data_json_row = {
      "sort": "study",
      "title": "수업",
      "subject": "",
      "percent": 0,
      "count": 0,
      "success_cnt": 0,
      "elapse_time_sec": 0,
      "per_arr": [],
      "todo_info_arr": [],
      "file_cnt": 0,
      "file_arr": [],
    };

    for (let i = 0; i < todo_info_arr_len; i++) {
      let todo_info = todo_info_arr[i];
      let subject = todo_info["a_subject"];
      if (strFunc.is_empty(subject)) {
        subject = "기타";
      }
      if (key == "pre_homework") {
        if (todo_info["a_reserve_start_date"].substring(0, 10) >= pre_date_str
          && todo_info["a_reserve_start_date"].substring(0, 10) < base_date_str) {
          if (todo_info["a_sort"] == "homework") {
            sort_data_json_row = this_obj.get_sort_data_json_row_stack_by_todo_info({
              sort_data_json_row: sort_data_json_row,
              todo_info: todo_info,
            });

            if (sort_data_json_row["subject_data_json"][subject] == undefined) {
              sort_data_json_row["subject_data_json"][subject] = {
                ...default_subject_data_json_row,
                "sort": sort_data_json_row["sort"],
                "title": sort_data_json_row["title"],
                "subject": subject,
                "per_arr": [],
                "todo_info_arr": [],
              };
              sort_data_json_row["subject_name_arr"].push(subject);
            }
            sort_data_json_row["subject_data_json"][subject] = this_obj.get_sort_data_json_row_stack_by_todo_info({
              sort_data_json_row: sort_data_json_row["subject_data_json"][subject],
              todo_info: todo_info,
            });
          }
        }
      } else if (todo_info["a_reserve_start_date"].substring(0, 10) == base_date_str) {
        let tmp_row_key = todo_info["a_sort"];
        if (tmp_row_key == "video") {
          tmp_row_key = "study";
        }
        if (tmp_row_key == key) {
          sort_data_json_row = this_obj.get_sort_data_json_row_stack_by_todo_info({
            sort_data_json_row: sort_data_json_row,
            todo_info: todo_info,
          });
          if (sort_data_json_row["subject_data_json"][subject] == undefined) {
            sort_data_json_row["subject_data_json"][subject] = {
              ...default_subject_data_json_row,
              "sort": sort_data_json_row["sort"],
              "title": sort_data_json_row["title"],
              "subject": subject,
              "per_arr": [],
              "todo_info_arr": [],
            };
            sort_data_json_row["subject_name_arr"].push(subject);
          }
          sort_data_json_row["subject_data_json"][subject] = this_obj.get_sort_data_json_row_stack_by_todo_info({
            sort_data_json_row: sort_data_json_row["subject_data_json"][subject],
            todo_info: todo_info,
          });
        }
      }
    }

    return sort_data_json_row;
  };
  static get_sort_data_json_row_stack_by_todo_info(inData: any) {
    let opt_obj = {
      sort_data_json_row: {},
      todo_info: {},
      ...inData
    };
    let sort_data_json_row = opt_obj.sort_data_json_row;
    let todo_info = opt_obj.todo_info;

    sort_data_json_row["count"]++;
    sort_data_json_row["elapse_time_sec"] += parseInt(strFunc.uncomma(todo_info.elapse_time_sec));
    let row_per: any = TodoStateFunc.get_percent_by_todo_info(todo_info);
    if (todo_info["a_is_success"] == "1") {
      if(row_per<100){
        row_per = 100;
      }
    }
    sort_data_json_row["per_arr"].push(row_per);
    todo_info["percent"] = row_per;
    sort_data_json_row["todo_info_arr"].push(todo_info);
    if (todo_info["a_is_success"] == "1") {
      sort_data_json_row["success_cnt"]++;
    }

    if (todo_info.file_arr) {
      sort_data_json_row["file_cnt"] += todo_info.file_arr.length;
      sort_data_json_row["file_arr"] = [
        ...sort_data_json_row["file_arr"],
        ...todo_info.file_arr
      ];
    }

    return sort_data_json_row;
  };
  static average_percent_arr_by_opt(inData: any) {
    let opt_obj = {
      per_arr: [],
      is_max_per: false,
      max_per: 100,
      ...inData
    };
    let per_arr = opt_obj.per_arr;
    let is_max_per = opt_obj.is_max_per;
    let max_per = opt_obj.max_per;
    let per_sum_num = 0;
    let per_sum_count = 0;
    let per_arr_len = per_arr.length;
    for (let i = 0; i < per_arr_len; i++) {
      let row_per_num = parseInt(strFunc.uncomma(per_arr[i]));
      if (is_max_per) {
        if (row_per_num > max_per) {
          row_per_num = max_per;
        }
      }
      per_sum_num += row_per_num;
      per_sum_count++;
    }
    let aver_per = 0;
    if (per_sum_count != 0 && per_sum_num != 0) {
      aver_per = Math.floor(per_sum_num / per_sum_count);
    }
    return aver_per;
  }
}
export default TodoInfoArrFunc;